// src/lib/apiErrors.js
//
// One reader for every FastAPI error shape the Patient API returns:
//
//   { detail: "text" }
//   { detail: [{ loc, msg, type }, ...] }              validation list
//   { detail: { message, errors: [...] } }
//   { detail: { code, message, retryable, ... } }      structured scheduling error
//
// Only human text is surfaced. Raw JSON, ids and request internals are never
// shown or logged.

function textOf(entry) {
  if (!entry) return "";
  if (typeof entry === "string") return entry;
  if (typeof entry.msg === "string") return entry.msg;
  if (typeof entry.message === "string") return entry.message;
  return "";
}

export function apiErrorCode(error) {
  const detail = error?.response?.data?.detail;
  return detail && typeof detail === "object" && !Array.isArray(detail) ? detail.code || null : null;
}

export function readApiError(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data;
  const detail = data?.detail !== undefined ? data.detail : data;

  if (typeof detail === "string" && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const messages = detail.map(textOf).filter(Boolean);
    if (messages.length) return messages.join(" ");
  }

  if (detail && typeof detail === "object") {
    const parts = [];
    if (typeof detail.message === "string" && detail.message.trim()) parts.push(detail.message);
    if (Array.isArray(detail.errors)) parts.push(...detail.errors.map(textOf).filter(Boolean));
    if (parts.length) return parts.join(" ");
  }

  if (!error?.response && error?.message === "Network Error") {
    return "We couldn't reach the server. Check your connection and try again.";
  }
  return fallback;
}
